<template>
    <div class="dokan-quote-form-wrapper">
        <tabs/>
        <h1 class="wp-heading-inline">{{ pageTitle }}</h1>
        <a @click="$router.go(-1)" class="page-title-action">{{ __( 'Go Back', 'dokan' ) }}</a>

        <hr class="wp-header-end">

        <form action="" method="post" id="post">
            <div id="poststuff">
                <div id="post-body" class="metabox-holder flex sm:flex-col md:flex-row gap-5">
                    <div class="md:!w-[80%] post-body-content" :class="checkRtl">
                        <div id="titlediv">
                            <div id="titlewrap">
                                <input type="text" v-model="rule.rule_name" name="rule_name" size="30" id="title" autocomplete="off" :placeholder="__('Enter rule title', 'dokan')" required="required">
                            </div>
                            <div class="inside"></div>
                        </div>

                        <div id="postdivrich" class="postarea wp-editor-expand">
                            <postbox :title="__( 'Rule settings', 'dokan' )" extraClass="request-rule-settings">
                                <div v-if="ruleErrorMessage.length > 0">
                                    <ul class="error-message" v-for="(error, index) in ruleErrorMessage" :key="index">
                                        <li>{{ error }}</li>
                                    </ul>
                                </div>
                                <table class="form-table">
                                    <tr>
                                        <th class="cat_text">
                                            <label>
                                                {{ __( 'Apply quote for', 'dokan' ) }}
                                            </label>
                                        </th>
                                        <td>
                                            <ul class="all_cats">
                                                <li v-for="(name, index) in allRoles" class="per_cat" :key="index">
                                                    <input :id="index" type="checkbox" class="parent" :value="index" v-model="rule.selected_user_role" />
                                                    <label :for="index">{{ name }}</label>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Apply on All Products', 'dokan' ) }}</th>
                                        <td id="row-apply-all-product">
                                            <switches :enabled="rule.apply_on_all_product" :value="rule.apply_on_all_product" @input="handleProductDropdown"></switches>
                                            <label class="apply-all-product-label" for="apply_on_all_product">
                                                {{ __( 'Check this if you want to apply this rule on all products.', 'dokan' ) }}
                                            </label>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown">
                                        <th>{{ __( 'Specific Products', 'dokan' ) }}</th>
                                        <td>
                                            <switches :enabled="rule.switches.product_switch" :value="rule.switches.product_switch ? 1 : 0" @input="onProductSwitch"></switches>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown && rule.switches.product_switch">
                                        <th>{{ __( 'Include Products', 'dokan' ) }}</th>
                                        <td>
                                            <multiselect v-model="rule.product_ids" id="ajax" label="name" track-by="id" :placeholder="__( 'Type to search', 'dokan' )" open-direction="bottom" :options="requested_products" :multiple="true" :searchable="true" :internal-search="false" :clear-on-select="true" :close-on-select="false" :options-limit="300" :limit="10" :limit-text="limitText" :max-height="700" :show-no-results="false" :hide-selected="true" @search-change="searchProducts">
                                                <span slot="noResult">{{ __( 'Oops! No elements found. Consider changing the search query.', 'dokan' ) }}</span>
                                            </multiselect>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown && rule.switches.product_switch">
                                        <th>{{ __( 'Exclude Products', 'dokan' ) }}</th>
                                        <td>
                                            <multiselect v-model="rule.exclude_product_ids" id="ajax" label="name" track-by="id" :placeholder="__( 'Type to search', 'dokan' )" open-direction="bottom" :options="requested_exclude_products" :multiple="true" :searchable="true" :internal-search="false" :clear-on-select="true" :close-on-select="false" :options-limit="300" :limit="10" :limit-text="limitText" :max-height="700" :show-no-results="false" :hide-selected="true" @search-change="searchExcludeProducts">
                                                <span slot="noResult">{{ __( 'Oops! No elements found. Consider changing the search query.', 'dokan' ) }}</span>
                                            </multiselect>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown">
                                        <th class="cat_text">
                                            <label>
                                                {{ __( 'Specific Categories', 'dokan' ) }}
                                            </label>
                                        </th>
                                        <td>
                                            <switches :enabled="rule.switches.category_switch" :value="rule.switches.category_switch ? 1 : 0" @input="onCategorySwitch"></switches>
                                            <div class="all_cats" v-if="rule.switches.category_switch">
                                                <categoryList
                                                    v-for="(category, index) in requestedCategories"
                                                    :key="category.id"
                                                    :label="category.name"
                                                    :nodes="category.children"
                                                    :hasChildren="category.hasChildren"
                                                    :id="category.id"
                                                    :savedCategories = "rule.category_ids"
                                                    @clickedCategory="checkCategory"
                                                    :depth="0"
                                                ></categoryList>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown">
                                        <th>{{ __( 'Specific Vendors', 'dokan' ) }}</th>
                                        <td>
                                            <switches :enabled="rule.switches.vendor_switch" :value="rule.switches.vendor_switch ? 1 : 0" @input="onVendorSwitch"></switches>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown && rule.switches.vendor_switch">
                                        <th>{{ __( 'Include Vendors', 'dokan' ) }}</th>
                                        <td>
                                            <multiselect v-model="rule.store_ids" id="ajax" label="name" track-by="id" :placeholder="__( 'Type to search', 'dokan' )" open-direction="bottom" :options="stores" :multiple="true" :searchable="true" :internal-search="false" :clear-on-select="true" :close-on-select="false" :options-limit="300" :limit="10" :limit-text="limitText" :max-height="700" :show-no-results="false" :hide-selected="true" @search-change="asyncStoreFind">
                                                <span slot="noResult">{{ __( 'Oops! No elements found. Consider changing the search query.', 'dokan' ) }}</span>
                                            </multiselect>
                                        </td>
                                    </tr>
                                    <tr v-show="showProductsDropdown && rule.switches.vendor_switch">
                                        <th>{{ __( 'Exclude Vendors', 'dokan' ) }}</th>
                                        <td>
                                            <multiselect v-model="rule.exclude_store_ids" id="ajax" label="name" track-by="id" :placeholder="__('Type to search', 'dokan')" open-direction="bottom" :options="exclude_stores" :multiple="true" :searchable="true" :internal-search="false" :clear-on-select="true" :close-on-select="false" :options-limit="300" :limit="10" :limit-text="limitText" :max-height="700" :show-no-results="false" :hide-selected="true" @search-change="asyncExcludeStoreFind">
                                                <span slot="noResult">{{ __( 'Oops! No elements found. Consider changing the search query.', 'dokan' ) }}</span>
                                            </multiselect>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Expire Limit', 'dokan' ) }}</th>
                                        <td>
                                            <switches :enabled="rule.switches.expire_switch" :value="0" @input="onExpireSwitch"></switches>
                                            <input class="expire-limit" v-if="rule.switches.expire_switch" type="number" v-model="rule.expire_limit" size="50" min="1" autocomplete="off" :placeholder="__( 'Type expiration day', 'dokan' )" />
                                            <span class="quote-field-desc" v-if="rule.switches.expire_switch">
                                                {{ __( 'Quote Valid for X Days After Quote Accepted/Approved.', 'dokan' ) }}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Hide Price', 'dokan' ) }}</th>
                                        <td>
                                            <switches :enabled="rule.hide_price == 1 ? true : false" :value="rule.hide_price ? 1 : 0" @input="onHidePrice" id="announcement_sender_type"></switches>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Hide Price Text', 'dokan' ) }}</th>
                                        <td class="hide-price-text">
                                            <span v-if="!rule.hide_price" class="input-overlay"></span>
                                            <input type="text" v-model="rule.hide_price_text" size="50" autocomplete="off" :disabled="!rule.hide_price" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Hide Add to Cart Button', 'dokan' ) }}</th>
                                        <td class="hide-price-text">
                                            <span v-if="rule.hide_price" class="input-overlay"></span>
                                            <div class='quote-radio-fields'>
                                                <label v-for='( item, index ) in quoteRules' :class="item.value === rule.hide_cart_button ? 'checked' : ''" :key="`${index}-${item.value}`" :for="`${index}-${item.value}-${index}`">
                                                    <input
                                                        type='radio'
                                                        class='radio'
                                                        :value="item.value"
                                                        @change="onChangeRule"
                                                        :name="'dokan-group-radio-input'"
                                                        :id="`${index}-${item.value}-${index}`"
                                                        :checked="item.value === rule.hide_cart_button"
                                                    />
                                                    {{ item.label }}
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ __( 'Custom Button Label', 'dokan' ) }}</th>
                                        <td>
                                            <input class="quote-bnt-label" type="text" v-model="rule.button_text" name="button_text" size="30" autocomplete="off" required="required">
                                            <span class="quote-field-desc">{{ __('Display the above label on custom button, e.g "Request a Quote"', 'dokan')}}</span>
                                        </td>
                                    </tr>
                                </table>
                            </postbox>
                        </div>
                    </div>

                    <div class="md:!w-[20%] postbox-container">
                        <postbox :title="__( 'Publish', 'dokan' )" extraClass="quote-actions">
                            <div class="action">
                                <input type="submit" class="button button-default draft-btn" :value="draftBtnLabel" @click.prevent="createQuoteRules('draft')" :disabled="loadSpinner">
                                <span class="spinner" v-if="loadSpinner"></span>
                                <input type="submit" class="button button-primary publish-btn" :value="publishBtnLabel" @click.prevent="createQuoteRules(createStatus)" :disabled="loadSpinner">
                                <div class="clear"></div>
                            </div>
                        </postbox>
                        <postbox :title="__( 'Rule priority', 'dokan' )" extraClass="quote-actions">
                            <div class="order-priority-desc">
                                <strong>
                                    {{ __('Order', 'dokan')}}
                                    <i
                                        class="dashicons dashicons-editor-help tips"
                                        :title="__( 'Order Priority will be 0>1>2>3...\n' + 'Last one in the list will get priority when two (or more) rules have same priority 0,0,0...', 'dokan' )"
                                        v-tooltip="__( 'Order Priority will be 0>1>2>3...\n' + 'Last one in the list will get priority when two (or more) rules have same priority 0,0,0...', 'dokan' )"
                                    ></i>
                                </strong>
                            </div>
                            <input type="number" class="order-priority-field" v-model="rule.rule_priority" autocomplete="off" required="required">
                        </postbox>
                    </div>
                </div>
                <br class="clear">
            </div>
        </form>
    </div>
</template>

<script>
import Tabs from '../components/Tabs.vue';
import categoryList from '../components/CategoryList.vue';

const Postbox             = dokan_get_lib('Postbox')
const apiBase             = 'request-for-quote/quote-rule';
const Debounce            = dokan_get_lib('debounce');
const Switches            = dokan_get_lib('Switches');
const Multiselect         = dokan_get_lib('Multiselect')
const roleApiBase         = 'request-for-quote/roles';
const requestQuoteApiBase = 'request-for-quote';

const swal = Swal.mixin({
    customClass: {
        confirmButton: 'button button-primary',
        cancelButton: 'button button-secondary'
    },
    buttonsStyling: false
});

export default {
    name: 'NewQuoteRules',

    components: {
        Tabs,
        Postbox,
        Switches,
        Debounce,
        Multiselect,
        categoryList,
    },

    data () {
        return {
            loading: false,
            showProductsDropdown: true,
            createStatus: 'publish',
            isOpen: '',
            allRoles: [],
            requested_products: [],
            requestedCategories: [],
            quoteRules: [
                {
                    value : 'replace',
                    label : this.__( 'Replace Add to Cart button with a Quote Button', 'dokan' ),
                },
                {
                    value : 'keep_and_add_new',
                    label : this.__( 'Keep Add to Cart button and add a new Quote Button', 'dokan' ),
                },
            ],
            stores: [],
            rule: {
                rule_name: '',
                store_ids: [],
                product_ids: [],
                category_ids: [],
                hide_price: 1,
                expire_limit: 30,
                hide_price_text: this.__('Price is hidden', 'dokan'),
                button_text: this.__('Add to quote', 'dokan'),
                rule_priority: 0,
                hide_cart_button: 'replace',
                rule_contents: [],
                exclude_store_ids: [],
                selected_user_role: [],
                exclude_product_ids: [],
                apply_on_all_product: 0,
                switches: {
                    vendor_switch   : false,
                    expire_switch   : false,
                    product_switch  : false,
                    category_switch : false,
                },
            },
            pageTitle: this.__('Add New Rules', 'dokan'),
            loadSpinner: false,
            draftBtnLabel: this.__('Save as Draft', 'dokan'),
            publishBtnLabel: this.__('Publish', 'dokan'),
            exclude_stores: [],
            ruleErrorMessage: [],
            requested_exclude_products: [],
        }
    },
    computed: {
        checkRtl () {
            return isRtl === 1 && isRtl !== undefined ? 'lang_rtl' : ''
        },
    },

    methods: {
        toggle: function(id) {
            this.isOpen = (this.isOpen !== id) ? id : '';
        },
        checkedItem(id, itemArray){
            return itemArray.includes(id);
        },
        fetchRoles(){
            this.loading = true;

            dokan.api.get('/' + roleApiBase).done((response) => {
                this.allRoles = response.role_names;
                this.allRoles['dokan_wholesale_customer'] = 'Wholesale customer';
                this.allRoles['guest'] = 'Guest';
                this.loading = false;
            });
        },
        limitText (count) {
            return this.__(`and ${count} other products`, 'dokan');
        },
        searchProducts: Debounce( function( search = '' ) {
            let self = this;
            if ( search.length < 1 ) {
                return;
            }

            const excluded_products = this.rule.exclude_product_ids;
            dokan.api.get( '/products', {
                search: search,
                request_a_quote: 1,
            })
            .done( ( response ) => {
                this.requested_products = response.map( function (item) {
                    return {
                        id: item.id,
                        name: item.name,
                    }
                }).filter( function (item) {
                    return !excluded_products.some( product => product.id === item.id );
                });
            })
            .fail( (response) => {
                self.filter.stores = [ { id: 0, name: self.__( 'No product found', 'dokan' ) } ];
                let message = dokan_handle_ajax_error( response );
                if ( message ) {
                    self.showAlert( message, '', 'error' );
                }
            });
        }, 300 ),
        searchExcludeProducts: Debounce( function( search = '' ) {
            let self = this;
            if ( search.length < 1 ) {
                return;
            }

            const included_products = this.rule.product_ids;
            dokan.api.get( '/products', {
                search: search,
                request_a_quote: 1,
            })
                .done( ( response ) => {
                    this.requested_exclude_products = response.map( function (item) {
                        return {
                            id: item.id,
                            name: item.name,
                        }
                    }).filter( function (item) {
                         return !included_products.some( product => product.id === item.id );
                    });
                })
                .fail( (response) => {
                    self.filter.stores = [ { id: 0, name: self.__( 'No product found', 'dokan' ) } ];
                    let message = dokan_handle_ajax_error( response );
                    if ( message ) {
                        self.showAlert( message, '', 'error' );
                    }
                });
        }, 300 ),
        asyncStoreFind: Debounce( function( query = '' ) {
            this.isLoading = true
            if ( query.length < 1 ) {
                return;
            }

            const excluded_stores = this.rule.exclude_store_ids;
            dokan.api.get('/stores', { search: query }).done(response => {
                this.isLoading = false
                this.stores = _.map(response, function (item) {
                    return {
                        id   : item.id,
                        name : item.store_name,
                    };
                }).filter( function (item) {
                    return !excluded_stores.some( store => store.id === item.id );
                });
            });
        }, 300 ),
        asyncExcludeStoreFind: Debounce( function( query = '' ) {
            this.isLoading = true
            if ( query.length < 1 ) {
                return;
            }

            const included_stores = this.rule.store_ids;
            dokan.api.get('/stores', { search: query }).done(response => {
                this.isLoading = false
                this.exclude_stores = _.map(response, function (item) {
                    return {
                        id   : item.id,
                        name : item.store_name,
                    };
                }).filter( function (item) {
                    return !included_stores.some( store => store.id === item.id );
                });
            });
        }, 300 ),
        searchCategory(){
            dokan.api.get('/products/multistep-categories').done(response => {
                let th = this;
                Object.values(response).forEach(function(item) {
                    if ( item.parent_id != 0 ) {
                        return;
                    }
                    let catData = { id: Number(item.term_id), name: item.name, hasChildren: false };
                    if ( item.children.length > 0 ) {
                        catData.hasChildren = true;
                        catData.children = th.getChildCategories( response, item.children );
                    }

                    th.requestedCategories.push(catData);
                });
            });
        },
        getChildCategories( data, children ) {
            let childCategories = [];
            let th = this;
            children.forEach(function(item) {
                let childCategory = {
                    id: Number(data[item].term_id),
                    name: data[item].name,
                    hasChildren: false,
                };
                if ( data[item].children.length > 0 ) {
                    childCategory.hasChildren = true;
                    childCategory.children = th.getChildCategories( data, data[item].children );
                }
                childCategories.push(childCategory);
            });
            return childCategories;
        },
        createQuoteRules (status) {
            if (this.$route.params.id) {
                this.updateQuoteRule(status, this.$route.params.id);
            }else {
                this.saveQuoteRules(status);
            }
        },
        getFilteredJsonData(status){
            let jsonData = jQuery.extend({}, this.rule);
            jsonData.status = status;
            jsonData.product_ids = ! jsonData.apply_on_all_product && Array.isArray(jsonData.product_ids)
                ? jsonData.product_ids.map(item => {
                return item.id;
            }) : [];

            jsonData.exclude_product_ids = ! jsonData.apply_on_all_product && Array.isArray(jsonData.exclude_product_ids)
                ? jsonData.exclude_product_ids.map(item => {
                    return item.id;
                }) : [];

            jsonData.category_ids = ! jsonData.apply_on_all_product && Array.isArray(jsonData.category_ids)
                ? jsonData.category_ids.map(item => {
                return item;
            }) : [];

            jsonData.store_ids = ! jsonData.apply_on_all_product && Array.isArray(jsonData.store_ids)
                ? jsonData.store_ids.map(item => {
                    return item.id;
                }) : [];

            jsonData.exclude_store_ids = ! jsonData.apply_on_all_product && Array.isArray(jsonData.exclude_store_ids)
                ? jsonData.exclude_store_ids.map(item => {
                    return item.id;
                }) : [];

            return jsonData;
        },
        validateFormFields(ruleData){
            let isValid = true;
            this.ruleErrorMessage = [];

            if (ruleData.rule_name === '' || ruleData.rule_name === undefined) {
                this.ruleErrorMessage.push(this.__('Please enter rule name.', 'dokan'));
                isValid = false;
            }

            if(ruleData.selected_user_role.length <= 0){
                this.ruleErrorMessage.push(this.__('Please select at least one user role.', 'dokan'));
                isValid = false;
            }

            if(ruleData.hide_price_text === '' || ruleData.hide_price_text === undefined){
                this.ruleErrorMessage.push(this.__('Please enter hide price text.', 'dokan'));
                isValid = false;
            }

            if (ruleData.button_text === '' || ruleData.button_text === undefined) {
                this.ruleErrorMessage.push(this.__('Please enter button text.', 'dokan'));
                isValid = false;
            }

            if (ruleData.switches.expire_switch) {
                const expireLimit = ruleData.expire_limit,
                    isValidPositiveInteger = /^[1-9]\d*$/.test(expireLimit);

                if (!isValidPositiveInteger) {
                    this.ruleErrorMessage.push(this.__('Please enter a valid positive integer for quote expiration days limit.', 'dokan'));
                    isValid = false;
                }

                if (isNaN(expireLimit)) {
                    this.ruleErrorMessage.push(this.__('Please enter a valid number for quote expiration days limit.', 'dokan'));
                    isValid = false;
                }

                if (parseInt(expireLimit) < 1) {
                    this.ruleErrorMessage.push(this.__('Expire Limit Can\'t be Less Than 1.', 'dokan'));
                    isValid = false;
                }
            }

            return isValid;
        },
        saveQuoteRules(status){
            this.loadSpinner = true
            let jsonData = this.getFilteredJsonData(status);

            if ( ! this.validateFormFields(jsonData) ) {
                this.loadSpinner = false
                return false;
            }

            dokan.api.post('/' + apiBase, jsonData )
            .done( response => {
                this.loadSpinner = false;
                this.sendToPages();
            })
            .fail( (response) => {
                this.loadSpinner = false;
                let message = dokan_handle_ajax_error( response );
                if ( message ) {
                    self.showAlert( message, '', 'error' );
                }
            });
        },
        updateQuoteRule (status, id) {
            this.loadSpinner = true
            let jsonData = this.getFilteredJsonData(status);
            jsonData.id = id;

            if ( ! this.validateFormFields(jsonData) ) {
                this.loadSpinner = false
                return false;
            }

            dokan.api.put('/' + apiBase +'/' + id, jsonData )
            .done( response => {
                this.loadSpinner = false;
                this.sendToPages();
            })
            .fail( (response) => {
                this.loadSpinner = false;
                let message = dokan_handle_ajax_error( response );
                if ( message ) {
                    self.showAlert( message, '', 'error' );
                }
            });
        },
        sendToPages(){
            this.$router.push({
                name: 'RequestAQuoteRules',
            });
        },
        checkCategory(id){
            var index = this.rule.category_ids.indexOf(id);
            if ( index >= 0){
                this.rule.category_ids.splice(index, 1);
            }else {
                this.rule.category_ids.push(id);
                if (Array.isArray(id)) {
                    this.rule.category_ids = id;
                }
            }
        },
        fetchAQuoteRule(id){
            this.loading = true;

            dokan.api.get('/' + apiBase + '/' + id).done((response) => {
                this.rule = response;
                this.rule.hide_price = parseInt(response.hide_price);
                this.rule.apply_on_all_product = parseInt(response.apply_on_all_product);
                if (this.rule.apply_on_all_product) {
                    this.showProductsDropdown = false;
                }
                this.pageTitle = this.__('Edit Rule', 'dokan');
                this.loading = false;
                this.rule.store_ids = response.store_ids.map( store => {
                    return { id: store.store_id, name: store.store_name };
                } );

                this.rule.exclude_store_ids = response.exclude_store_ids.map( store => {
                    return { id: store.store_id, name: store.store_name };
                } );

                for ( let key in response.switches ) {
                    if ( response.switches.hasOwnProperty( key ) ) {
                        this.rule.switches[key] = ( response.switches[key] === "true" );
                    }
                }
            }).fail( (response) => {
                this.loadSpinner = false;
                let message = dokan_handle_ajax_error( response );
                if ( message ) {
                    self.showAlert( message, '', 'error' );
                }
            });
        },
        showAlert( $title, $des, $status ) {
            swal.fire( $title, $des, $status );
        },
        handleProductDropdown( status ) {
            this.showProductsDropdown      = ! this.showProductsDropdown;
            this.rule.apply_on_all_product = status;
        },
        onProductSwitch( status ) {
            this.rule.switches.product_switch = status;
        },
        onCategorySwitch( status ) {
            this.rule.switches.category_switch = status;
        },
        onVendorSwitch( status ) {
            this.rule.switches.vendor_switch = status;
        },
        onExpireSwitch( status ) {
            this.rule.switches.expire_switch = status;
        },
        onHidePrice( status ) {
            if ( status ) {
                this.rule.hide_cart_button = 'replace';
            }

            this.rule.hide_price = status;
        },
        onChangeRule( event ) {
            this.rule.hide_cart_button = event.target.value;
        },
    },

    created () {
        if (this.$route.params.id) {
            this.fetchAQuoteRule(this.$route.params.id);
        }
        this.fetchRoles();
        this.searchCategory();
    },


}
</script>

<style lang="less">

.dokan-quote-form-wrapper {
    position: relative;
    .error-message {
        background-color: #f2dede;
        color: #ff0000;
        padding: 10px;
    }
    .help-block {
        position: absolute;
        top: 10px;

        span.help-text {
            display: inline-block;
            margin-top: 4px;
            margin-right: 6px;

            a {
                text-decoration: none;
            }
        }

        span.dashicons {
            font-size: 25px;
        }
    }

    .help-block-rtl {
        left: 10px;
    }

    .help-block-ltr {
        right: 10px;
    }

    #post-body {
        .post-body-content {
            position: relative;
            width: 100%;
            min-width: 463px;
            float: left;
            margin-bottom: 20px;

            #postdivrich {
                margin-top: 20px;

                .request-rule-settings {
                    #row-apply-all-product {
                        gap: 10px;
                        display: flex;
                        align-items: center;
                    }

                    .switch {
                        & ~ .apply-all-product-label,
                        &:not(#announcement_sender_type) {
                            margin: 3px 0 12px;
                        }
                    }

                    .quote-radio-fields {
                        row-gap: 8px;
                        display: grid;
                        margin-top: 4px;

                        label {
                            cursor: pointer;
                        }
                    }
                }

                td {
                    &.hide-price-text {
                        position: relative;

                        span.input-overlay {
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            opacity: 0.5;
                            display: block;
                            overflow: hidden;
                            background: white;
                            position: absolute;
                        }
                    }

                    .quote-field-desc {
                        display: block;
                        margin: 4px 0 0 2px;
                    }
                }

                .expire-limit,
                .quote-bnt-label {
                    width: 450px;
                    display: block;
                }
            }
        }

        .quote-actions {
            background: #fafafa;

            .order-priority-desc {
                margin-bottom: 10px;
            }

            .order-priority-field {
                width: 100%;
            }

            .action {
                padding: 15px 0px;

                .spinner {
                    visibility: visible;
                    float: none;
                }

                .draft-btn {
                    float: left;
                }

                .publish-btn {
                    float: right;
                }
            }

            .sub-action {
                #jj, #aa, #hh, #mm {
                    padding: 1px;
                    font-size: 12px;
                }

                #jj, #hh, #mm {
                    width: 2em;
                }

                #timestamp {
                    .dashicons {
                        &:before {
                            color: #82878c;
                            position: relative;
                            top: -1px;
                        }
                    }
                }
            }
        }
    }
    .multiselect {
        input#ajax {
            background: none !important;
            box-shadow: none !important;
            outline: 0 !important;
            border: none !important;
        }
    }
    .subCategory{
        cursor: pointer;
    }
    .all_cats {
        width: 50%;
        border: solid 1px #b6b1b1;
        border-radius: 4px;
        padding: 10px;
        max-height: 250px;
        overflow-y: scroll;
        .all_sub_cats {
            padding: 10px;
        }
    }
    .per_cat {
        width: auto;
        padding: 5px;
    }
    .cat_text {
        vertical-align: top;
    }
}
.lang_rtl {
    float: right !important;
}

input[type="checkbox"]:checked::before {
    content: url(data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2020%2020%27%3E%3Cpath%20d%3D%27M14.83%204.89l1.34.94-5.81%208.38H9.02L5.78%209.67l1.34-1.25%202.57%202.4z%27%20fill%3D%27%233582c4%27%2F%3E%3C%2Fsvg%3E) !important;
}

input[type=checkbox] {
    margin-top: 0 !important;
}
</style>
